import React from "react";
import Logo from "../../assets/images/curenza-logo.png";

import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const handleCardClick = (typeOfWorkObj) => {
    navigate(`/services?typeOfWork=${typeOfWorkObj.id}`);
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer-logo">
              <img src={Logo} alt="" />
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-3">
                <div className="footer-links">
                  <h3>Company</h3>
                  <ul>
                    <li>
                      <Link to="/about-us">About us </Link>
                    </li>
                    <li>
                      <Link to="/terms-condition">Terms & conditions </Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy policy </Link>
                    </li>
                    <li>
                      <Link to="/anti-discrimination-policy">
                        Anti-discrimination policy{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/careers">Careers </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-3">
                <div className="footer-links">
                  <h3>For customers</h3>
                  <ul>
                    <li>
                      <Link to="/services">Services near you</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Our Blogs</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-3">
                <div className="footer-links">
                  <h3>Popular Services</h3>
                  <ul>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 44,
                          workTypeName: "CCTV - Repair & AMC ",
                        })
                      }
                    >
                      <Link>CCTV - Repair and AMC</Link>
                    </li>

                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 8,
                          workTypeName: "DG - AMC and Service",
                        })
                      }
                    >
                      <Link to="">DG - AMC and Service</Link>
                    </li>

                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 40,
                          workTypeName: "WTP - Filter Service",
                        })
                      }
                    >
                      <Link to="">WTP - Filter Service</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 40,
                          workTypeName: "STP - Filter Service",
                        })
                      }
                    >
                      <Link to="">STP - Filter Service </Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 33,
                          workTypeName: "Motors/Pumps - Repair & Service",
                        })
                      }
                    >
                      <Link to="">Motors/Pumps - Repair and Service</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 37,
                          workTypeName: "Fire & Safety",
                        })
                      }
                    >
                      <Link to="">Fire & Safety</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 30,
                          workTypeName: "HT & LT works",
                        })
                      }
                    >
                      <Link to="">HT & LT works</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 19,
                          workTypeName: "Lift Maintenance",
                        })
                      }
                    >
                      <Link to="">Lift - Repair and Service</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 10,
                          workTypeName: "Borewell - New & Service",
                        })
                      }
                    >
                      <Link to="">Borewell - New and Service</Link>
                    </li>
                    <li
                      onClick={() =>
                        handleCardClick({
                          id: 7,
                          workTypeName: "Transformer Service/AMC",
                        })
                      }
                    >
                      <Link to="">Transformer - Annual Service/AMC </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-3">
                <div className="footer-links">
                  <h3>For partners</h3>
                  <ul>
                    <li>
                      <Link to="/vendor-register">
                        Register as a professional{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="copyright-section">
              <p>
                {" "}
                © 2025 - All right reserved Curenza | Developed by{" "}
                <Link
                  className="orange-link"
                  to={"https://www.nextwebi.com/"}
                  target="_blank"
                >
                  Nextwebi
                </Link>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
